import { render } from "./UserAuditions.vue?vue&type=template&id=2f033eb2"
import script from "./UserAuditions.vue?vue&type=script&lang=js"
export * from "./UserAuditions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__